import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { OrganisationResponseInterface } from '@careapp/angular-sdk';

/**
 * This class represents the toolbar component.
 */
@Component({
  selector: 'ca-toolbar',
  templateUrl: 'toolbar.component.html',
  styleUrls: ['toolbar.component.scss']
})
export class ToolbarComponent {
  @Input()
  loggedIn: boolean;

  @Input()
  sidenav: MatSidenav;

  @Input()
  admin: boolean;

  @Input()
  currentOrganisation: OrganisationResponseInterface;

  @Input()
  organisations: OrganisationResponseInterface[];

  @Input()
  user: string;

  @Input()
  appLink: string;

  @Output()
  profile = new EventEmitter<any>();

  @Output()
  logout = new EventEmitter<any>();
}
